export const handleLogout = () => {
  localStorage.removeItem('isAuthenticated')
  window.location.href = '/login'
}
